import React, { useState } from "react";
import AlertMessage from "../../../../partials/alertMessage";

/**
 *
 * @param {function} onSubmit a  function to call on submission of the form
 */
const NewWardForm = ({ onSubmit }) => {
	const [message, setMessage] = useState(null);
	const nameRef = React.createRef();
	const descRef = React.createRef();
	return (
		<form
			method="POST"
			onSubmit={e => {
				e.preventDefault();
				const name = nameRef.current.value;
				const desc = descRef.current.value;
				if (name && desc) {
					onSubmit({ name, desc });
					setMessage(null);
					nameRef.current.value = "";
					descRef.current.value = "";
				} else {
					setMessage("Ward's name and description are required!");
				}
			}}
		>
			<AlertMessage message={message} failed={true} />
			<div className="form-row">
				<div className="col-4">
					<input
						type="text"
						id="new-ward"
						name="new-ward"
						ref={nameRef}
						className="form-control input-height"
						placeholder="New ward"
					/>
				</div>
				<div className="col-6">
					<input
						type="text"
						id="desc-ward"
						name="desc"
						ref={descRef}
						className="form-control input-height"
						placeholder="Ward description"
					/>
				</div>
				<div className="col">
					<button
						type="submit"
						className="mdl-button mdl-button--raised mdl-js-ripple-effect m-l-10 m-b-10 btn-circle btn-success"
					>
						Add <i className="material-icons">keyboard_arrow_down</i>
					</button>
				</div>
			</div>
		</form>
	);
};

export default NewWardForm;
